import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../../loading.service';
import { SignAssociationControllerRequestService } from '../sign-association-controller-request.service';
import { SignTitleAdjustment } from '../../../../model/sign/title/sign-title-adjustment';
import { SignTitleAdjustmentOverview } from '../../../../model/sign/title/sign-title-adjustment-overview';
import { SnackService } from '../../../snack.service';

@Injectable({
  providedIn: 'root',
})
export class SignTitleAdjustmentControllerRequestService extends SignAssociationControllerRequestService<
  SignTitleAdjustment,
  SignTitleAdjustmentOverview
> {
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    super(http, snackService, loadingService, router, '/signtitleadjustments');
  }

  protected override deserializeImpl(): (res: any) => SignTitleAdjustment {
    return (res) => res as SignTitleAdjustment;
  }
}
